import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import * as dashboardActions from "src/redux/slices/dashboardSlice";
import BarChart from "src/components/ui/chart/BarChart";
import { currencyFormatter } from "src/utils/common";

interface PurchaseOverviewCardProps {
  days: number;
  enabled?: boolean;
}

const PurchaseOverviewCard: React.FC<PurchaseOverviewCardProps> = ({
  days,
  enabled = true,
}) => {
  const dispatch = useAppDispatch();
  const { tenantPurchaseOverview } = useAppSelector((state) => state.dashboard);

  useEffect(() => {
    if (!enabled) return;
    dispatch(dashboardActions.getTenantPurchaseOverviewRequest({ days }));
  }, [dispatch, days, enabled]);

  if (!enabled) return null;

  const data = tenantPurchaseOverview.data?.data || [];

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-semibold text-gray-700">
          Purchase Overview
        </h2>
        <span className="text-xs text-gray-400">This week</span>
      </div>
      <BarChart
        data={data}
        dataKey="totalPurchases"
        xKey="date"
        hideXAxis
        hideYAxis
        barColor="#93C5FD"
        barRadius={[8, 8, 8, 8]}
        tooltipFormatter={(value?: number) =>
          currencyFormatter(value || 0, "IN", 2)
        }
      />
    </div>
  );
};

export default PurchaseOverviewCard;
